import Button from '@/components/button/Button';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { styles } from './styles';
import { UserDTO } from '@/data/DTOs/UserDTO';
import { AllSignUpSteps } from './SignUpSteps';
import { Success } from '@/components/success/Success';
import { useNavigate } from 'react-router-dom';
import { StepperBase } from '@/components/stepper/Stepper';
import { Country } from '@/components/countryAutoComplete/countries';

const SignUp = () => {
  const { t } = useTranslation([
    'signInPersonalInfo',
    'signInAddress',
    'success',
  ]);
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [confirmSign, setConfirmSign] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const [createdUser, setCreatedUser] = useState(false);
  const [country, setCountry] = useState<Country | undefined>();
  const [user, setUser] = useState<UserDTO>({
    id: '',
    name: '',
    surname: '',
    birthDate: '',
    gender: '',
    email: '',
    phone: '',
    countryCode: '()',
    zip: '',
    address: '',
    complement: '',
    password: '',
    city: '',
    state: '',
    picture: undefined,
  });
  const allSteps = AllSignUpSteps({
    changeStep,
    setUser,
    user,
    loading,
    setLoading,
    showWarning,
    setShowWarning,
    warningMessage,
    setWarningMessage,
    country,
    setCountry,
    createdUser,
    setCreatedUser,
  });

  function changeStep(nextStep: boolean) {
    setShowWarning(false);
    if (nextStep) {
      if (currentStep < allSteps.length - 1) {
        const newStep = currentStep + 1;
        setCurrentStep(newStep);
      } else {
        setConfirmSign(true);
      }
    } else {
      if (currentStep === 0) {
        navigate('/');
      } else {
        const newStep = currentStep - 1;
        setCurrentStep(newStep);
      }
    }
  }

  useEffect(() => {
    const storedUser = sessionStorage.getItem('signupUser');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      sessionStorage.removeItem('signupUser');
    }
  }, []);

  useEffect(() => {
    const savedStep = sessionStorage.getItem('signupStep');
    if (savedStep !== null) {
      const stepNumber = parseInt(savedStep, 10);
      if (!isNaN(stepNumber)) {
        setCurrentStep(stepNumber);
      }
      sessionStorage.removeItem('signupStep');
    }
  }, []);

  const signPage = (
    <Box sx={styles.content}>
      <Box sx={styles.header}>
        <Box sx={styles.title}>
          <Button
            sx={styles.button}
            onClick={() => changeStep(false)}
            iconButton={<ArrowBackIosIcon />}
            size={'medium'}
          />
          <Typography sx={styles.welcome_text}>
            {t('create_account_title')}
          </Typography>
        </Box>
        <StepperBase steps={allSteps.length} currentStep={currentStep} />

        <Typography sx={styles.text}>
          {t(allSteps[currentStep].title)}
        </Typography>
      </Box>
      {allSteps[currentStep].page}
    </Box>
  );

  const confirmSuccess = (
    <Box sx={styles.contentSuccess}>
      <Success
        title={t('success:sign_in_success_title')}
        description={t('success:sign_in_success_description')}
        buttonTitle={t('success:sign_in_success_button')}
        onButtonClick={() => navigate('/')}
      />
    </Box>
  );

  return (
    <Box sx={styles.container}>{confirmSign ? confirmSuccess : signPage}</Box>
  );
};

export default SignUp;
